import { useLocation } from "react-router-dom";
import styles from "./Footer.module.css";
import { Menu } from "./Menu";

const Footer = () => {
  let location = useLocation();
  if (location.pathname.startsWith("/lores")) {
    return;
  }
  return (
    <div className={styles.footer}>
      <Menu />
    </div>
  );
};

export default Footer;
